/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceInventoryDetails {
    getFixupPrototypeFunction() { return ServiceResourceInventoryDetails.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceInventoryDetails>): ServiceResourceInventoryDetails {
        let obj = Object.assign(new ServiceResourceInventoryDetails(), model);
        ServiceResourceInventoryDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceInventoryDetails>): ServiceResourceInventoryDetails {
        if (!model) return null;
        return ServiceResourceInventoryDetails.newInstance(<ServiceResourceInventoryDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceInventoryDetails) {
        if (!obj) return;

        models.ServiceResourceInventoryDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceInventoryDetails): boolean {
        Object.setPrototypeOf(obj, ServiceResourceInventoryDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the resource
     */
    corestack_resource_id: string;

    /**
     * ID of the service account
     */
    service_account_id: string;

    /**
     * Unique id of the resource
     */
    check_resource_element: string;

    /**
     * Component of the resource
     */
    component: string;

    /**
     * Location of the resource
     */
    location: string;

    /**
     * Resource group name specific to Azure resource
     */
    resource_group: string;

    /**
     * Resource name specific to Azure
     */
    summary_details_name: string;

}
